import React from 'react'

const LrNoTable = ({ lrNolist, removelrno }) => {
	console.log(lrNolist)
	return (
		<div className='mt-5 overflow-hidden rounded-[22px] border border-slate-200 bg-white'>
            <div className='grid grid-cols-2 bg-[#fffaf6] px-4 py-3 text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>
                <p>Order Number</p>
                <p>Action</p>
            </div>
			{lrNolist?.length ? lrNolist?.map((item, index) => (
				<div key={index} className='grid grid-cols-2 border-t border-slate-100 px-4 py-3 text-sm font-[GilroyMedium] text-slate-700'>
					<p>{item}</p>
					<button type='button' onClick={() => removelrno(item)} className='w-fit font-[GilroyBold] text-red-500 transition hover:text-red-600'>Remove</button>
				</div>
			)) : (
				<div className='px-4 py-10 text-center text-sm font-[GilroyMedium] text-slate-400'>No order numbers added yet.</div>
			)}
		</div>
	)
}

export default LrNoTable
